const keys: Array<string> = [
    "mzp.points.empty",
    "mzp.points.date",
    "mzp.points.type",
    "mzp.points.points",
    "loy.points.description.P",
    "loy.points.description.O",
    "loy.points.description.B",
    "loy.points.description.C",
    "loy.points.description.E",
    "loy.points.description.EX",
    "loy.points.description.FS",
    "mzp.filter.year",
    "mzp.points.pointsoverview",
    "loy.points.bannertitle",
    "loy.points.bannersubtitle",
    "loy.points.howtobenefit",
    "loy.points.collect",
    "loy.points.collect2",
    "loy.points.earn",
    "loy.points.earn2",
    "loy.points.redeem",
    "loy.points.redeem2",
    "loy.points.rules.title",
    "loy.points.rules.1",
    "loy.points.rules.2",
    "loy.points.rules.3",
    "loy.points.rules.4",
    "loy.points.expiry",
    "loy.bp.what-are-zoopoints",
    "loy.rewardshop.link",
    "loy.points.available",
    "loy.bp.gift.announcement.subtitle",
    "loy.bp.gift.announcement",
    "mzp.overview.bonus-program.view-reward-shop"
]

export default keys
